import ReDeadlinePage from "./page";
export default ReDeadlinePage;
